import React from 'react'

// Illustration for the "Bare" row style.
// The row gets padding only, so the content sits straight on the page with
// no panel behind it. We draw two columns of content and no boxes at all.
export default function IconContainerStyleBare({ ...rest }) {
    return (
        <svg width='56' height='36' viewBox='0 0 56 36' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
            {/* left column content */}
            <rect x='0' y='12' width='25' height='3' rx='1.5' fill='#C4C4C1' />
            <rect x='0' y='18' width='25' height='2' rx='1' fill='#DCDCDA' />
            <rect x='0' y='22' width='17' height='2' rx='1' fill='#DCDCDA' />
            {/* right column content */}
            <rect x='31' y='12' width='25' height='3' rx='1.5' fill='#C4C4C1' />
            <rect x='31' y='18' width='25' height='2' rx='1' fill='#DCDCDA' />
            <rect x='31' y='22' width='17' height='2' rx='1' fill='#DCDCDA' />
        </svg>
    )
}
